module.exports = __webpack_public_path__ + "static/media/project1.ea622924.png";